export const LEGACY_REPORT_TYPE = {
    donors: 'OLD_DASHBOARD_DONORS',
    donations: 'OLD_DASHBOARD_DONATIONS',
    disbursments: 'OLD_DASHBOARD_DISBURSEMENTS',
    'import-friendly': 'OLD_DASHBOARD_IMPORT_FRIENDLY',
    'by-envelope': 'OLD_DASHBOARD_QUICKBOOKS_DONATIONS_BY_ENVELOPE',
    'by-donor': 'OLD_DASHBOARD_QUICKBOOKS_DONATIONS_BY_DONOR',
};
